/**
 * 受伤部位
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} data
 * @returns
 */
export const SelectInjurySiteById = (Id) => {
  return get('/api/app/injurySite?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddInjurySite = (data) => {
  return post('/api/app/injurySite', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyInjurySite = (data) => {
  return put('/api/app/injurySite', data, {});
}

/**
 * 分页获取所属行业
 * @param {*} data
 * @returns
 */
export const GetDataInjurySiteList = (data) => {
  return post('/api/app/injurySite/list', data, {});
}

/**
 * 删除 记录
 * @param {*} id
 * @returns
 */
export const DeleteInjurySite = (id) => {
  return del('/api/app/injurySite/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
export const ExportInjurySite = (data) => {
  let defaluturl = `/api/app/InjurySite/exportExcelFile`;
  let fileName = "受伤部位"
  return download(fileName, defaluturl, data);
}